import { css } from "@emotion/react";

import transition from "~/utilities/transition";

import {
    baseTextDecorationCss,
    hoverTextDecorationCss,
} from "~/styles/helpers";

const getButtonColor = (active, theme, color, disabled) => {
    switch (color) {
        case "white":
            return css`
                background-color: ${theme.palette.white};
                color: ${
                    active ? theme.palette.precisionBlue : theme.palette.purple
                };

                &:hover,
                &:focus {
                    color: ${
                        disabled
                            ? theme.palette.purple
                            : theme.palette.precisionBlue
                    };
                }
            `;
        case "productLinkFocus":
            return css`
                background-color: ${
                    active
                        ? theme.palette.precisionBlue
                        : theme.palette.productLinkFocus
                };
                color: ${theme.palette.white};

                &:hover,
                &:focus {
                    background-color: ${theme.palette.black};
                }
            `;
        case "gray":
            return css`
                background-color: ${
                    active ? theme.palette.purple : theme.palette.grayThree
                };
                color: ${active ? theme.palette.white : theme.palette.purple};

                &:hover,
                &:focus {
                    color: ${
                        disabled ? theme.palette.purple : theme.palette.white
                    };
                    background-color: ${theme.palette.black};
                }
            `;
        case "purple":
            return css`
                background-color: ${
                    active ? theme.palette.precisionBlue : theme.palette.purple
                };
                color: ${theme.palette.white};

                &:hover,
                &:focus {
                    background-color: ${theme.palette.black};
                }
            `;
        case "precisionBlue":
            return css`
                background-color: ${
                    active ? theme.palette.black : theme.palette.precisionBlue
                };
                color: ${theme.palette.white};

                &:hover,
                &:focus {
                    background-color: ${theme.palette.black};
                }
            `;
        default:
            return css`
                background-color: ${
                    active ? theme.palette.precisionBlue : theme.palette.purple
                };
                color: ${theme.palette.white};

                &:hover,
                &:focus {
                    background-color: ${theme.palette.black};
                }
            `;
    }
};

export const getTableIconButtonCss = ({
    theme,
    color,
    hoverColor,
    flexDirection = "column",
    textFontSize = "1.1rem",
    showTextDecoration = false,
}) => {
    return css`
        ${transition({}, "all")};
        display: flex;
        flex-direction: ${flexDirection};
        align-items: center;
        justify-content: center;
        gap: 3px;
        color: ${color ?? theme.colors.typography.links};
        margin: 0 auto;
        ${showTextDecoration ? baseTextDecorationCss : ""};

        svg {
            margin-right: -2px;
        }

        span {
            font-size: ${textFontSize};
            text-wrap: nowrap;
        }

        &:hover,
        &:focus {
            color: ${hoverColor ?? theme.palette.precisionBlue};
            ${showTextDecoration ? hoverTextDecorationCss : ""};
        }
    `;
};

const buttonStyles = ({
    active,
    theme,
    color,
    large,
    noMinWidth,
    disabled,
}) => css`
    ${getButtonColor(active, theme, color, disabled)};
    ${transition({}, "color", "background-color")};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 2rem;
    line-height: 1;
    font-weight: 700;
    opacity: ${disabled ? `.5` : `1`};
    padding: ${large ? `15px 24px` : `10px 24px`};
    border-radius: ${
        large ? theme.button.borderRadiusLarge : theme.button.borderRadius
    };
    min-width: ${
        large && !noMinWidth
            ? theme.button.minWidthLarge
            : theme.button.minWidth
    };
    cursor: ${disabled ? `not-allowed` : `pointer`};
`;

export default buttonStyles;
